/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./blank.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./blank.component";
var styles_BlankComponent = [i0.styles];
var RenderType_BlankComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_BlankComponent, data: {} });
export { RenderType_BlankComponent as RenderType_BlankComponent };
export function View_BlankComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_BlankComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-blank", [], null, null, null, View_BlankComponent_0, RenderType_BlankComponent)), i1.ɵdid(1, 114688, null, 0, i2.BlankComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var BlankComponentNgFactory = i1.ɵccf("app-blank", i2.BlankComponent, View_BlankComponent_Host_0, {}, {}, []);
export { BlankComponentNgFactory as BlankComponentNgFactory };
